<template>
  <div class="container">
    <div class="survey-title mb40 has-text-centered">How would you describe your <span
        class="highlight-text">relationship</span> with cannabis?</div>
    <div class="fields-block mb60">
      <h3 class="title has-text-centered">Please select one.</h3>
      <div class="columns is-mobile justify-content-center">
        <div class="column">
          <div class="field is-grouped is-flex-tablet justify-content-center align-items-center">
            <div class="control pref-block mr5 ml5 has-text-centered">
              <input v-model="relationship" class="is-checkradio is-block" id="pref-relation-new" type="radio"
                name="pref-relation" value="New">
              <label for="pref-relation-new"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-new.svg" alt="" class="mb10">
                <h4 class="pref-label">New</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 has-text-centered">
              <input v-model="relationship" class="is-checkradio is-block" id="pref-relation-familiar" type="radio"
                name="pref-relation" value="Familiar">
              <label for="pref-relation-familiar"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-familiar.svg" alt="" class="mb10">
                <h4 class="pref-label">Familiar</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 has-text-centered">
              <input v-model="relationship"  class="is-checkradio is-block" id="pref-relation-expert" type="radio"
                name="pref-relation" value="Expert">
              <label for="pref-relation-expert"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-expert.svg" alt="" class="mb10">
                <h4 class="pref-label">Expert</h4>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="steps mt100 mb50">
      <ul class="is-flex justify-content-around">
        <li class="is-active"></li>
        <li class=""></li>
        <li class=""></li>
        <li class=""></li>
        <li class=""></li>
        <li class=""></li>
        <li class="mr0"></li>
      </ul>
    </div>
    <div class="next-button has-text-centered mb50">
      <a href="#" @click.prevent="next()" class="button is-primary">Next</a>
    </div>
    <div class="skip-button has-text-centered mb30">
      <a href="#" @click.prevent="setStep(2)" class="is-primary">Skip</a>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      relationship: '',
    };
  },
  computed: {
    ...mapGetters({
      step: "usersurvey/step"
    })
  },
  methods: {
    next() {
      if(this.relationship == '') {
        this.setSnackbar({
          modal: true,
          message: 'Please select your relationship with cannabis.',
          type: 'warning',
        }) 
      } else {
        this.setSurvey({
          relationship: this.relationship
        })
        this.setStep(2);
      }
    },
    ...mapActions({
      setSnackbar: "snackbar/setSnackbar",
      setStep: "usersurvey/setStep",
      setSurvey: "usersurvey/setSurvey"
    })
  },
};
</script>